/* eslint-disable */

import ModalSkeleton from '../ModalSkeleton';
import classes from './HomeMoreFiltersModal.module.css';
// import Button from '../../Component/Button/Button';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Button from '../../Component/Button/Button';
import {
  floorLevelFilterOptions,
  furnitureFiltersOptions,
  parkingSpaceFilterOptions,
  propertyAgeFilterOptions,
  rentTypes
} from '../../constant/commonData';

const HomeMoreFiltersModal = ({
  filterType,
  show,
  setShow,
  // onClick, isLoading
  children,
  setFilters,
  filters,
  onSearch
}) => {
  const pathName = useLocation().pathname;
  const { t } = useTranslation('landingPageFilters');
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { interiorAmenities, exteriorAmenities } = useSelector((state) => state?.commonReducer);

  const [selectedExteriorAmenities, setSelectedExteriorAmenities] = useState(
    Array.isArray(filters?.exteriorAmenities) ? filters?.exteriorAmenities : []
  );

  const [selectedInteriorAmenities, setSelectedInteriorAmenities] = useState(
    Array.isArray(filters?.interiorAmenities) ? filters?.interiorAmenities : []
  );

  const [propertyType, setPropertyType] = useState(
    filters?.propertyType || filters?.rentType || []
  );
  const [parkingSpace, setParkingSpace] = useState(filters?.parkingSpace || []);
  const [propertyAge, setPropertyAge] = useState(filters?.propertyAge || []);
  const [isFurniture, setIsFurniture] = useState(filters?.furniture || []);
  const [floorLevel, setFloorLevel] = useState(filters?.floorLevel || []);
  const [rentType, setRentType] = useState(filters?.rentType || []);
  const tabsData = [
    { id: 1, text: t('buy') },
    { id: 2, text: t('rent') }
  ];
  const [target, setTarget] = useState(null);
  const handleClick = (e, type) => {
    setTarget(e?.target);
    setShow(type);
  };
  const onApply = () => {
    const filterData = {
      ...filters,
      //
      propertyType: propertyType,
      floorLevel: floorLevel,
      parkingSpace: parkingSpace,
      furniture: isFurniture,
      propertyAge: propertyAge,
      interiorAmenities: selectedInteriorAmenities,
      exteriorAmenities: selectedExteriorAmenities
    };

    setFilters && setFilters(filterData);
    // Modify Data According to the Filter

    const filterParams = {
      // parkingSpace:
      //   parkingSpace &&
      //   parkingSpaceFilterOptions?.findIndex(
      //     (a) => a?.[selectedLanguage] == parkingSpace?.[selectedLanguage]
      //   ) !== 0
      //     ? {
      //         quantity: parkingSpace?.value,
      //         more: !!parkingSpace?.more
      //       }
      //     : '',
      parkingSpace: parkingSpace?.length
        ? parkingSpace
            ?.filter(
              (item) =>
                parkingSpaceFilterOptions?.findIndex(
                  (a) => a?.[selectedLanguage] === item?.[selectedLanguage]
                ) !== 0
            )
            ?.map((item) => ({
              quantity: item?.value,
              more: !!item?.more
            }))
        : '',

      // floorLevel:
      //   floorLevelFilterOptions?.findIndex(
      //     (a) => a?.[selectedLanguage] == floorLevel?.[selectedLanguage]
      //   ) != 0
      //     ? floorLevel?.[selectedLanguage]
      //     : '',
      floorLevel:
        floorLevelFilterOptions?.findIndex(
          (a) => a?.[selectedLanguage] == floorLevel?.[0]?.[selectedLanguage]
        ) !== 0
          ? floorLevel?.map((e) => e?.[selectedLanguage])
          : '',
      // furniture:
      //   furnitureFiltersOptions?.findIndex(
      //     (a) => a?.[selectedLanguage] == isFurniture?.[selectedLanguage]
      //   ) !== 0
      //     ? isFurniture?.[selectedLanguage]
      //     : '',
      furniture:
        furnitureFiltersOptions?.findIndex(
          (a) => a?.[selectedLanguage] == isFurniture?.[0]?.[selectedLanguage]
        ) !== 0
          ? isFurniture?.map((e) => e?.[selectedLanguage])
          : '',
      // propertyAge:
      //   propertyAgeFilterOptions?.findIndex(
      //     (a) => a?.[selectedLanguage] == propertyAge?.[selectedLanguage]
      //   ) !== 0
      //     ? propertyAge?.[selectedLanguage]
      //     : '',
      propertyAge:
        propertyAgeFilterOptions?.findIndex(
          (a) => a?.[selectedLanguage] == propertyAge?.[0]?.[selectedLanguage]
        ) !== 0
          ? propertyAge?.map((e) => e?.[selectedLanguage])
          : '',
      rentType:
        propertyType?.length > 0
          ? propertyType
              .filter(
                (item) =>
                  rentTypes?.findIndex(
                    (a) => a?.[selectedLanguage] === item?.[selectedLanguage]
                  ) !== 0
              )
              .map((item) => item?.[selectedLanguage])
          : '',
      interiorAmenities: selectedInteriorAmenities?.map((e) => e?._id),
      exteriorAmenities: selectedExteriorAmenities?.map((e) => e?._id)
    };

    onSearch && onSearch(filterParams);
  };
  return (
    <ModalSkeleton
      width={'600px'}
      show={show}
      setShow={setShow}
      footerStyles={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 10px',
        width: '100%'
      }}
      header={t('filters')}
      headerClass={classes.headerClass_headerClass}
      footer={
        <Button
          className={classes.btn}
          onClick={() => {
            onApply && onApply();
            setShow(false);
          }}>
          {t('apply')}
        </Button>
      }
      modalClass={classes.modal}>
      <Row className={classes.row}>
        {children}
        {/* <h6>{t('propertyType')}</h6> */}
        {pathName?.endsWith('rent') && (
          <>
            <Col md={12}>
              <h6>{t('rentType')}</h6>
            </Col>
            <Col md={12}>
              <ul className={classes.listSelection}>
                {rentTypes?.map((item, key) => {
                  const propertyTypeArr = Array.isArray(propertyType) ? propertyType : [];
                  const isSelected = propertyTypeArr?.some(
                    (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
                  );
                  const isAny =
                    item?.[selectedLanguage] === 'Any' ||
                    item?.[selectedLanguage] === 'Tümü' ||
                    item?.[selectedLanguage] === 'الكل' ||
                    item?.[selectedLanguage] === 'Tout' ||
                    item?.[selectedLanguage] === 'Все' ||
                    item?.[selectedLanguage] === 'Irgendein' ||
                    item?.[selectedLanguage] === 'همه' ||
                    item?.[selectedLanguage] === 'هر';

                  return (
                    <li
                      key={key}
                      data-selected={isSelected}
                      onClick={() => {
                        setPropertyType((prevRaw) => {
                          const prev = Array.isArray(prevRaw) ? prevRaw : [];
                          if (isAny) {
                            return [item];
                          }
                          const wasAnySelected = prev?.some(
                            (selectedItem) =>
                              selectedItem?.[selectedLanguage] === 'Any' ||
                              selectedItem?.[selectedLanguage] === 'Tümü' ||
                              selectedItem?.[selectedLanguage] === 'الكل' ||
                              selectedItem?.[selectedLanguage] === 'Tout' ||
                              selectedItem?.[selectedLanguage] === 'Все' ||
                              selectedItem?.[selectedLanguage] === 'Anye' ||
                              selectedItem?.[selectedLanguage] === 'همه'
                          );
                          if (isSelected) {
                            return prev.filter(
                              (selectedItem) =>
                                selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                            );
                          } else {
                            if (wasAnySelected) {
                              return [item];
                            } else {
                              return [...prev, item];
                            }
                          }
                        });
                      }}>
                      {item?.[selectedLanguage]}
                    </li>
                  );
                })}
              </ul>
            </Col>
          </>
        )}
        <Col md={12}>
          <h6>{t('floorLevel')}</h6>
        </Col>
        {/* <Col md={12}>
          <ul className={classes.listSelection}>
            {floorLevelFilterOptions?.map((item, key) => (
              <li
                key={key}
                data-selected={item?.[selectedLanguage] == floorLevel?.[selectedLanguage]}
                onClick={() => {
                  setFloorLevel((prev) =>
                    prev?.[selectedLanguage] == item?.[selectedLanguage] ? '' : item
                  );
                }}>
                {item?.[selectedLanguage]}
              </li>
            ))}
          </ul>
        </Col> */}
        <Col md={12}>
          <ul className={classes.listSelection}>
            {floorLevelFilterOptions?.map((item, key) => {
              const floorLevelArr = Array.isArray(floorLevel) ? floorLevel : [];
              const isSelected = floorLevelArr?.some(
                (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
              );
              const isAny =
                item?.[selectedLanguage] === 'Any' ||
                item?.[selectedLanguage] === 'Tümü' ||
                item?.[selectedLanguage] === 'الكل' ||
                item?.[selectedLanguage] === 'Tout' ||
                item?.[selectedLanguage] === 'Все' ||
                item?.[selectedLanguage] === 'Anye' ||
                item?.[selectedLanguage] === 'همه';

              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setFloorLevel((prevRaw) => {
                      const prev = Array.isArray(prevRaw) ? prevRaw : [];
                      if (isAny) {
                        return [item];
                      }
                      const wasAnySelected = prev?.some(
                        (selectedItem) =>
                          selectedItem?.[selectedLanguage] === 'Any' ||
                          selectedItem?.[selectedLanguage] === 'Tümü' ||
                          selectedItem?.[selectedLanguage] === 'الكل' ||
                          selectedItem?.[selectedLanguage] === 'Tout' ||
                          selectedItem?.[selectedLanguage] === 'Все' ||
                          selectedItem?.[selectedLanguage] === 'Anye' ||
                          selectedItem?.[selectedLanguage] === 'همه'
                      );
                      if (isSelected) {
                        return prev.filter(
                          (selectedItem) =>
                            selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                        );
                      } else {
                        if (wasAnySelected) {
                          return [item];
                        } else {
                          return [...prev, item];
                        }
                      }
                    });
                  }}>
                  {item?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>
        <Col md={12}>
          <h6>{t('parkingSpace')}</h6>
        </Col>
        <Col md={12}>
          <ul className={classes.listSelection}>
            {/* {parkingSpaceFilterOptions?.map((item, key) => (
              <li
                key={key}
                data-selected={item?.[selectedLanguage] == parkingSpace?.[selectedLanguage]}
                onClick={() => {
                  setParkingSpace((prev) =>
                    prev?.[selectedLanguage] == item?.[selectedLanguage] ? '' : item
                  );
                }}>
                {item?.[selectedLanguage]}
              </li>
            ))} */}
            {/* {parkingSpaceFilterOptions?.map((item, key) => {
              const isSelected = parkingSpace.some(
                (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
              );

              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setParkingSpace((prev) => {
                      if (isSelected) {
                        // remove if already selected
                        return prev.filter(
                          (selectedItem) =>
                            selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                        );
                      } else {
                        // add if not selected
                        return [...prev, item];
                      }
                    });
                  }}>
                  {item?.[selectedLanguage]}
                </li>
              );
            })} */}

            {parkingSpaceFilterOptions?.map((item, key) => {
              const isSelected = parkingSpace?.some(
                (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
              );

              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setParkingSpace((prev) => {
                      const isAny =
                        item?.[selectedLanguage] === 'Any' ||
                        item?.[selectedLanguage] === 'Tümü' ||
                        item?.[selectedLanguage] === 'الكل' ||
                        item?.[selectedLanguage] === 'Tout' ||
                        item?.[selectedLanguage] === 'Все' ||
                        item?.[selectedLanguage] === 'Anye' ||
                        item?.[selectedLanguage] === 'همه';

                      // If clicked item is "Any"
                      if (isAny) {
                        return [item]; // Deselect all and select only "Any"
                      }

                      const wasAnySelected = prev?.some(
                        (selectedItem) =>
                          selectedItem?.[selectedLanguage] === 'Any' ||
                          selectedItem?.[selectedLanguage] === 'Tümü' ||
                          selectedItem?.[selectedLanguage] === 'الكل' ||
                          selectedItem?.[selectedLanguage] === 'Tout' ||
                          selectedItem?.[selectedLanguage] === 'Все' ||
                          selectedItem?.[selectedLanguage] === 'Anye' ||
                          selectedItem?.[selectedLanguage] === 'همه'
                      );

                      if (isSelected) {
                        // Deselect the current item
                        return prev.filter(
                          (selectedItem) =>
                            selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                        );
                      } else {
                        // If "Any" was selected, remove it and add the clicked item
                        if (wasAnySelected) {
                          return [item];
                        } else {
                          return [...prev, item];
                        }
                      }
                    });
                  }}>
                  {item?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>
        <Col md={12}>
          <h6>{t('furniture')}</h6>
        </Col>
        {/* <Col md={12}>
          <ul className={classes.listSelection}>
            {furnitureFiltersOptions?.map((item, key) => (
              <li
                key={key}
                data-selected={item?.[selectedLanguage] == isFurniture?.[selectedLanguage]}
                onClick={() => {
                  setIsFurniture((prev) =>
                    prev?.[selectedLanguage] == item?.[selectedLanguage] ? '' : item
                  );
                }}>
                {item?.[selectedLanguage]}
              </li>
            ))}
          </ul>
        </Col> */}

        <Col md={12}>
          <ul className={classes.listSelection}>
            {furnitureFiltersOptions?.map((item, key) => {
              const isFurnitureArr = Array.isArray(isFurniture) ? isFurniture : [];
              const isSelected = isFurnitureArr?.some(
                (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
              );
              const isAny =
                item?.[selectedLanguage] === 'Any' ||
                item?.[selectedLanguage] === 'Tümü' ||
                item?.[selectedLanguage] === 'الكل' ||
                item?.[selectedLanguage] === 'Tout' ||
                item?.[selectedLanguage] === 'Все' ||
                item?.[selectedLanguage] === 'Anye' ||
                item?.[selectedLanguage] === 'همه';

              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setIsFurniture((prevRaw) => {
                      const prev = Array.isArray(prevRaw) ? prevRaw : [];
                      if (isAny) {
                        return [item];
                      }
                      const wasAnySelected = prev?.some(
                        (selectedItem) =>
                          selectedItem?.[selectedLanguage] === 'Any' ||
                          selectedItem?.[selectedLanguage] === 'Tümü' ||
                          selectedItem?.[selectedLanguage] === 'الكل' ||
                          selectedItem?.[selectedLanguage] === 'Tout' ||
                          selectedItem?.[selectedLanguage] === 'Все' ||
                          selectedItem?.[selectedLanguage] === 'Anye' ||
                          selectedItem?.[selectedLanguage] === 'همه'
                      );
                      if (isSelected) {
                        return prev.filter(
                          (selectedItem) =>
                            selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                        );
                      } else {
                        if (wasAnySelected) {
                          return [item];
                        } else {
                          return [...prev, item];
                        }
                      }
                    });
                  }}>
                  {item?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>
        {/* <Col md={12} className={classes.checkboxDiv}>
          <Checkbox
            label={'Do you want to have furniture in the property?'}
            value={isFurniture}
            setValue={setIsFurniture}
          />
        </Col> */}
        {/* <Col md={12}>
          <h6>{t('propertyAge')}</h6>
        </Col> */}
        {/* <Col md={12}>
          <ul className={classes.listSelection}>
            {propertyAgeFilterOptions?.map((item, key) => (
              <li
                key={key}
                data-selected={item?.[selectedLanguage] == propertyAge?.[selectedLanguage]}
                onClick={() => {
                  setPropertyAge((prev) =>
                    prev?.[selectedLanguage] == item?.[selectedLanguage] ? '' : item
                  );
                }}>
                {item?.[selectedLanguage]}
              </li>
            ))}
          </ul>
        </Col> */}

        <Col md={12}>
          <h6>{t('propertyAge')}</h6>
        </Col>
        <Col md={12}>
          <ul className={classes.listSelection}>
            {propertyAgeFilterOptions?.map((item, key) => {
              // Ensure propertyAge is always an array
              const propertyAgeArr = Array.isArray(propertyAge) ? propertyAge : [];
              const isSelected = propertyAgeArr?.some(
                (selectedItem) => selectedItem?.[selectedLanguage] === item?.[selectedLanguage]
              );
              const isAny =
                item?.[selectedLanguage] === 'Any' ||
                item?.[selectedLanguage] === 'Tümü' ||
                item?.[selectedLanguage] === 'الكل' ||
                item?.[selectedLanguage] === 'Tout' ||
                item?.[selectedLanguage] === 'Все' ||
                item?.[selectedLanguage] === 'Anye' ||
                item?.[selectedLanguage] === 'همه';

              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setPropertyAge((prevRaw) => {
                      const prev = Array.isArray(prevRaw) ? prevRaw : [];
                      if (isAny) {
                        return [item];
                      }
                      const wasAnySelected = prev?.some(
                        (selectedItem) =>
                          selectedItem?.[selectedLanguage] === 'Any' ||
                          selectedItem?.[selectedLanguage] === 'Tümü' ||
                          selectedItem?.[selectedLanguage] === 'الكل' ||
                          selectedItem?.[selectedLanguage] === 'Tout' ||
                          selectedItem?.[selectedLanguage] === 'Все' ||
                          selectedItem?.[selectedLanguage] === 'Anye' ||
                          selectedItem?.[selectedLanguage] === 'همه'
                      );
                      if (isSelected) {
                        return prev.filter(
                          (selectedItem) =>
                            selectedItem?.[selectedLanguage] !== item?.[selectedLanguage]
                        );
                      } else {
                        if (wasAnySelected) {
                          return [item];
                        } else {
                          return [...prev, item];
                        }
                      }
                    });
                  }}>
                  {item?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>

        <Col md={12}>
          <h6>{t('exteriorAmenities')}</h6>
        </Col>
        <Col md={12}>
          <ul className={classes.listSelection}>
            {exteriorAmenities?.map((item, key) => {
              const isSelected = selectedExteriorAmenities?.some(
                (selectedItem) => selectedItem?._id === item?._id
              );
              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setSelectedExteriorAmenities((prev) => {
                      if (isSelected) {
                        return prev.filter((selectedItem) => selectedItem?._id !== item?._id);
                      } else {
                        return [...prev, item];
                      }
                    });
                  }}>
                  {item?.title?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>
        <Col md={12}>
          <h6>{t('interiorAmenities')}</h6>
        </Col>
        <Col md={12}>
          <ul className={classes.listSelection}>
            {interiorAmenities?.map((item, key) => {
              const isSelected = selectedInteriorAmenities?.some(
                (selectedItem) => selectedItem?._id === item?._id
              );
              return (
                <li
                  key={key}
                  data-selected={isSelected}
                  onClick={() => {
                    setSelectedInteriorAmenities((prev) => {
                      if (isSelected) {
                        return prev.filter((selectedItem) => selectedItem?._id !== item?._id);
                      } else {
                        return [...prev, item];
                      }
                    });
                  }}>
                  {item?.title?.[selectedLanguage]}
                </li>
              );
            })}
          </ul>
        </Col>
      </Row>
    </ModalSkeleton>
  );
};

export default HomeMoreFiltersModal;
